import { Link, LinkComponentProps } from "@tanstack/react-router";
import { cn } from "web-design-system";

interface PageNavbarProps {
  children: React.ReactNode;
  className?: string;
}

export function PageNavbar({ children, className }: PageNavbarProps) {
  return (
    <nav
      className={cn(
        "flex flex-row h-12 gap-6 px-5 pt-5 pb-2 border-b border-border",
        className
      )}
    >
      {children}
    </nav>
  );
}

export function PageNavbarItem(props: LinkComponentProps) {
  return (
    <Link
      {...props}
      className={cn(
        "hover:underline text-muted-foreground hover:underline-offset-[calc(0.675rem)] text-sm !decoration-2",
        "data-[status=active]:bg-background data-[status=active]:underline data-[status=active]:underline-offset-[calc(0.675rem)] data-[status=active]:text-primary data-[status=active]:font-semibold"
      )}
    >
      {props.children}
    </Link>
  );
}
